import { FormControl, FormGroup } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { MatDialog } from "@angular/material/dialog";
import { ViewerConfigurationService } from "../../viewer-components/services/viewer-configuration.service";
import { ChangeDetectorRef, Component, Input, inject } from "@angular/core";

@Component({
  template: "",
  standalone: false,
})
export abstract class ArcGISFeatureLayerComponent {
  protected readonly cdr = inject(ChangeDetectorRef);

  serviceTypes = [
    "FeatureServer",
    "GeocodeServer",
    "GeoDataServer",
    "GeometryServer",
    "GPServer",
    "GlobeServer",
    "ImageServer",
    "MapServer",
    "MobileServer",
    "SceneServer",
    "SchematicsServer",
    "StreamServer",
    "TopographicProductionServer",
    "NetworkDiagramServer",
    "ValidationServer",
    "VectorTileServer",
    "VersionManagementServer",
  ];

  setBbox(event) {
    this.useBbox = event.checked;
  }

  layers: any[] = [];

  isAuthRequired: boolean = false;

  username: string = "";

  password: string = "";

  hide = true;

  changed: boolean = true;

  isLoading = false;

  isUrlValid = false;

  useBbox = false;

  token: any;

  formatPercentLabel = (value: number) => `${value}%`;

  form = new FormGroup({
    isAuthRequired: new FormControl(null),
    username: new FormControl(""),
    password: new FormControl(""),
  });

  @Input()
  url: string;

  urlType: string;

  protected constructor(
    protected http: HttpClient,
    protected viewerConfigurationService: ViewerConfigurationService,
    protected matDialog: MatDialog,
  ) {}

  onAuthRequireChange(event: any) {
    this.isAuthRequired = event.value;
    this.changed = true;
    document.getElementById("lblError").innerHTML = "";
  }

  fieldsCompleted() {
    if (this.isAuthRequired) {
      return this.form.get("username").value !== "" && this.form.get("password").value !== "" && this.changed;
    }

    return this.changed;
  }

  changeInput() {
    this.changed = true;
  }

  usernameExists() {
    return this.form.get("username").value.length > 0;
  }

  passwordExists() {
    return this.form.get("password").value.length > 0;
  }

  getArcGISFeature() {
    this.isLoading = true;
    this.changed = false;
    document.getElementById("lblError").innerHTML = "";

    if (this.isAuthRequired) {
      this.getTokenArcGISFeatureServer();
    } else {
      this.getArcGISFeatureLayers();
    }
  }

  getArcGISFeatureLayers() {
    let url = `${this.url}?f=json`;
    if (this.isAuthRequired) url += `&token=${this.token}`;
    this.http
      .get(`${url}`, {
        responseType: "json",
      })
      .toPromise()
      .then((res) => {
        this.getArcGISFeatureLayersSuccess(res);
      })
      .catch(() => {
        this.getArcGISFeatureLayersError();
      });
  }

  getTokenArcGISFeatureServer() {
    const formData: any = new FormData();
    this.username = this.form.get("username").value;
    this.password = this.form.get("password").value;
    formData.append("username", this.username);
    formData.append("password", this.password);
    formData.append("referer", this.url);
    formData.append("f", "json");
    const url = "https://www.arcgis.com/sharing/rest/generateToken";
    this.http
      .post(url, formData)
      .toPromise()
      .then((res: any) => {
        this.token = res.token;
        this.getArcGISFeatureLayers();
      })
      .catch(() => {
        this.isLoading = false;
        this.cdr.detectChanges();
        document.getElementById("lblError").innerHTML = "Username or password wrong";
      });
  }

  getArcGISFeatureLayersSuccess(data) {
    if (data.layers) {
      this.layers = data.layers;
      this.isLoading = false;
      this.changed = true;
      this.cdr.detectChanges();
      this.loadLayers();
      document.getElementById("lblError").innerHTML = "";
    } else {
      this.isLoading = false;
      this.cdr.detectChanges();
      document.getElementById("lblError").innerHTML = "No layers returned";
    }
  }

  getArcGISFeatureLayersError() {
    this.isLoading = false;
    this.cdr.detectChanges();
    document.getElementById("lblError").innerHTML = "Failed to load url";
  }

  abstract loadLayers();
}
